import { centeredNotification } from './../../../utils/utility';

import { put, takeLatest } from 'redux-saga/effects';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import SendRequest from '../../../shared/services/sendRequest.service';
import * as leftSideBarActions from '../../actions/leftSideBarAction';
import actionTypes from '../../types/leftSideBarTypes';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import { COMMON_ERROR } from '../../../shared/constants/commonConstants';

const sendRequest = SendRequest.instance;

function* sideBarSaga(data: any): Generator {
  let response: any;
  const { payload: { chartPayload, getSideBarData } } = data;

  try {
    if (chartPayload) {
      response = yield SendRequest.instance.post<any, any>(chartPayload?.url, chartPayload?.payload);
    }
    if (response && response.isSuccess) {
      getSideBarData ? getSideBarData(response) :
        yield put(leftSideBarActions.fetchSideBarData(response));
    }
    return;
  } catch (e) {
  }
}

function* dashboardRequest(data: any): Generator {
  const { payload: { title, url, type, filter } } = data;
  yield put(leftSideBarActions.setSideBarHeader(title));
  const dashboardPayload = {
    url,
    payload: {
      profileId: ApplicationDetail.instance.getProfileId(),
      dashboardType: type,
      filter: filter ? filter : undefined,
    },
  };
  yield put(leftSideBarActions.setSideBarRequestPayload(dashboardPayload));
}

function* reimbursementRequest({payload}: any): Generator {
  try {
    const response: any = yield sendRequest.post<any, any>
      (`${GLOBAL_URL.CRM_BASE_URL}Provider/Search/ReimbursementChartDetails`, payload);

    if (response && response.isSuccess) {
      yield put(leftSideBarActions.fetchReimbursementDataSuccess(response));
    }
    return;
  } catch (e) {
  }
}

function* fetchProviderCreditsSaga(): Generator {
  try {
    const response: any = yield sendRequest.post<any, any>
      (`${GLOBAL_URL.CRM_BASE_URL}Provider/Search/ProviderCredits`, {});

    if (response && response.isSuccess) {
      yield put(leftSideBarActions.fetchProviderCreditsSuccess(response));
    }
    return;
  } catch (e) {
  }
}

function* downloadCreditReportSaga({payload}: any): Generator {
  try {
    yield sendRequest.post<any, any> (
      `${GLOBAL_URL.CRM_BASE_URL}Provider/Search/ProviderCreditReport`,
      {},
      { responseType: 'blob', isShowErrorInInterceptor: { isShowErrorInModal: false } },
    )
    .then((response: any): void => {
      const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
            'download',
            `CreditReport.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
    })
    .catch((error: any): void => {
      centeredNotification(COMMON_ERROR);
    });
  } catch (e) {
  }
}

export function* watchSideBarAction(): any {
  yield takeLatest(actionTypes.SIDEBAR_DATA, sideBarSaga);
  yield takeLatest(actionTypes.SET_DASHBOARD_REQUEST, dashboardRequest);
  yield takeLatest(actionTypes.FETCH_REIMBURSEMENT_REQUEST, reimbursementRequest);
  yield takeLatest(actionTypes.FETCH_PROVIDER_CREDITS, fetchProviderCreditsSaga);
  yield takeLatest(actionTypes.DOWNLOAD_CREDIT_REPORT, downloadCreditReportSaga);
}

export default watchSideBarAction;
